import { SelectItem } from 'primeng/api/selectitem';
import { Form_Data } from './util.models';

export class Specialty {
    id: number;
    specialty_name: string;
    is_supported?: boolean;
    featured_id?: boolean;
    speciality_url?: string;
    countryIds:string[] = [];
}

export class DepartmentSpecialty extends Specialty{
    serial: number
}


export class CrudSpeciality extends Specialty{
    file: any;
}

export class Specialty_data 
{
    api_data: CrudSpeciality = new CrudSpeciality();
    form_data: Form_Data = new Form_Data();
}